export default "/images/ThankYouForJoiningRecoatOurPlanet.webp?cfe85fcc87d3c11e012a6b82af261aa5";